import { IEnvironment, PROD_API, SENTRY_DSN } from './environment.interface';

export const environment: IEnvironment = {
  name: 'production',
  production: true,
  services: {
    api: PROD_API,
  },
  sentryDsn: SENTRY_DSN,
  googleAnalyticsId: 'GTM-PZN4MVSZ',
  frontappChatId: '4d6b4f8b2cdacb5db5f85d04bc4d0006',
  cookieHub: '8ca3c30b',
};
